export default class PostDetail {
	constructor() {
    // Check if single post page
    if (document.querySelector('.single-post')) {
      this.convertFeaturedImageDownloadOnIOS();
    }
  }
  
  convertFeaturedImageDownloadOnIOS() {
    // Check if iOS device
    const isIOS = document.querySelector('.ios') !== null;

    // Get featured image download container element
    const featuredImageDownloadContainerElement = document.querySelector('.post--video__hero__download-image');

    // Check if featured image download container element exist
    if (!featuredImageDownloadContainerElement) {
      return;
    }

    if (isIOS) {
      // Convert contents of featured image download container to a helper text for iOS users
      featuredImageDownloadContainerElement.innerHTML = 'Tap and hold the image to save';
    }

    // Show featured image download container element
    featuredImageDownloadContainerElement.classList.add('show');
  }
}
